export default __webpack_public_path__ + "static/media/logo_rating.2d2c3771.png";